<template>
    <user-manage-list/>
</template>

<script>
    import UserManageList from "_private/components/super/systemSetting/userManage/List";

    export default {
        components: {
            UserManageList
        }
    };
</script>
